import { render, staticRenderFns } from "./automaticUpload.vue?vue&type=template&id=1ed4fa56"
import script from "./automaticUpload.vue?vue&type=script&lang=js"
export * from "./automaticUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports